<template>
  <div class="c-theme">
    <div class="c-them-head c-title" v-if="value.COLUMNNAME == null || value.COLUMNNAME == ''" v-show="false"></div>
    <div v-else class="c-them-head c-title">
      <div class="c-hd-title"></div>
      <div class="c-hd-title">{{ value.COLUMNNAME }}</div>
      <router-link v-show="false" class="c-more" :to="'/theme/' + value.MoreId">More<i
          class="icon iconfont icon-gengduo2"></i></router-link>
    </div>
    <div class="c-them-body">
      <!--      <div v-show="true" ref="Index" id="Index" class="active-index">0</div>-->
      <div class="c-them-swiper" v-bind:style="{
        backgroundImage:
          'url(' +
          (value.BACKGROUNDPIC == null
            ? 'static/img/index_bg.png'
            : $bti.ServerUrl + value.BACKGROUNDPIC) +
          ')',
      }">
        <div class="c-them-tinfo" v-for="(item, index) of productData" :key="item.Id" :index="index"
          v-if="index === currentIndex">
          <router-link :to="$fun.getProductUrl(item.ID, item.ProductType)">
            <div class="c-them-bkname" ref="bkname">{{ item.Name }}</div>
            <div class="c-them-author" ref="author">{{ item.Author }}</div>
            <div class="c-them-desc" ref="desc">
              <template v-if="item.Introduction">{{
                $fun.delHtmlTag(item.Introduction)
              }}</template>
            </div>
          </router-link>
        </div>
        <div class="sc-img">
          <carousel-3d :autoplay="true" :autoplayTimeout="4000" :perspective="35" :display="11" :animationSpeed="1000"
            :width="219" :height="296" controlsVisible :controlsWidth="40" :controlsHeight="40" :border="0" :space="200"
            :clickable="false" @after-slide-change="onSlideChange" :disable3d="false" v-if="productData.length">
            <slide v-for="(item, index) of productData" :index="index" :key="item.Id">
              <template slot-scope="obj">
                <router-link :to="$fun.getProductUrl(item.Id, item.ProductType)">
                  <!-- <div class="img-tag1">{{item.SOURCEOPENTYPE == "01" ? '借阅' : '畅读' }}</div> -->
                  <template v-if="item.Cover"><img :src="item.Cover" :data-name="item.Name"
                      :data-author="item.Author" /></template>
                  <template v-else><img src="/static/img/np-img.png" /></template>
                  <!-- <span class="img-tag">{{ item.ProductTypeText }}</span> -->
                </router-link>
              </template>
            </slide>
          </carousel-3d>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel3d, Slide } from "vue-carousel-3d";
export default {
  name: "Theme",
  props: ["value"],
  components: {
    Carousel3d,
    Slide,
  },
  data: function () {
    return {
      currentIndex: 0,
      productData: [],
    };
  },
  mounted() {
    this.$bti
      .GetBelongToColumnPage({
        page: 1,
        rows: 12,
        wheres: {
          ColumnId: this.value.ID,
          OrgId: this.$fun.getMember().orgId,
          IsSingle: true,
        },
      })
      .then((res) => {
        if (res.code != 1) {
          return;
        }
        this.productData = res.data.rows;
      });
  },
  methods: {
    onSlideChange: function (index) {
      this.currentIndex = index;
    },
  },
};
</script>
<style lang="css" scoped>
.c-them-body {
  padding: 30px 0px;
}

.c-them-swiper {
  background: #fff;
  width: 100%;
  height: 480px;
  overflow: hidden;
}

.c-them-tinfo {
  width: 600px;
  height: 184px;
  margin: 0px auto;
  padding-top: 35px;
  color: #fff;
}

.c-them-tinfo a {
  display: block;
  cursor: pointer;
  color: #fff;
}

.c-them-tinfo .c-them-bkname {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}

.c-them-tinfo .c-them-author {
  text-align: center;
  font-size: 14px;
  padding: 15px 0 10px 0px;
  color: #ffef13;
}

.c-them-tinfo .c-them-desc {
  line-height: 1.6;
  height: 45px;
  overflow: hidden;
  font-size: 14px;
  color: #eee;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  width: 100%;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 1;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.carousel-3d-container {
  margin: 0px auto !important;
}

.carousel-3d-slide {
  border-radius: 8px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
}

.carousel-3d-slide img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}

.img-tag {
  right: 38%;
}

.sc-img {
  position: relative;
}

.sc-img .img-tag1 {
  position: absolute;
  top: 0;
  right: 0;
  width: 48px;
  height: 48px;
  background: linear-gradient(-135deg, #409EFF, #409EFF 50%, transparent 50%, transparent 100%);
  color: #fff;
  padding-left: 19px;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/Theme.vue